<template>
    <div>
        <div class="row" v-for="product in products" :key="'invoiceproduct_'+product.id">
            <div class="columns" >
                <div class="column is-4">
                    <strong>Naam</strong><br>
                    <b-input type="text" v-model="product.name" v-if="editingProducts" expanded></b-input>
                    <div v-else>
                        <p class="margin0 productname">
                            {{ product.name }}
                            <b-button tag="router-link" size="is-small" v-if="(product.type == 'box' || product.type == 'product') && product.product" :to="{ name: (product.type == 'box' ? 'BoxesRecord' : 'ProductsRecord'), params: { id: product.product } }" icon-right="external-link-alt"></b-button>
                        </p>
                        <p v-if="product.discount_type && product.discount_value" class="margin0">
                            <small class="has-text-success">
                                <!-- <b-icon icon="percent" size="is-small"></b-icon> -->
                                Korting: {{ product.discount_type === 'percentage' ? product.discount_value + '%' : '€' + number_format(product.discount_value) }}
                                <span v-if="product.discount_description" style="color: #666;">({{ product.discount_description }})</span>
                            </small>
                        </p>
                    </div>
                </div>
                <div class="column">
                    <strong>{{ product.type == 'box' ? '' : 'Aantal' }}</strong><br>
                    {{ product.type == 'box' ? '' : product.amount }}
                </div>
                <div class="column text-right">
                    <span v-if="type != 'credit'">
                        <strong>Borg</strong><br>
                        <span v-if="editingProducts">
                            <b-input type="text" v-model="product.deposit" icon="euro-sign" expanded></b-input>
                        </span>
                        <span v-else>
                            <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                            <span v-else>{{ product.deposit > 0 ? '€ '+number_format((product.amount ? product.amount : 1) * product.deposit) : '-' }}</span>
                        </span>
                    </span>
                </div>
                <div class="column text-right">
                    <strong>BTW prijs</strong><br>
                    <span v-if="editingProducts">
                        <b-input type="text" v-model="product.btw_price" icon="euro-sign" expanded></b-input>
                    </span>
                    <span v-else>
                        <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                        <span v-else>
                            <!-- Show original BTW with strikethrough if discount exists -->
                            <span v-if="product.org_price" style="text-decoration: line-through; color: #999; font-size: 0.9em;">
                                &euro;&nbsp;{{ number_format(calculateOriginalBtw(product)) }}
                            </span>
                            <br v-if="product.org_price">
                            &euro;&nbsp;{{ number_format(calculateBtwPriceWithDiscount(product)) }}
                        </span>
                    </span>
                </div>
                <div class="column text-right">
                    <strong>Totaal</strong><br>
                    <span v-if="editingProducts">
                        <b-input type="text" v-model="product.price" icon="euro-sign" expanded></b-input>
                    </span>
                    <span v-else>
                        <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                        <span v-else>
                            <!-- Show original price with strikethrough if discount exists -->
                            <span v-if="product.org_price" style="text-decoration: line-through; color: #999; font-size: 0.9em;">
                                &euro;&nbsp;{{ number_format(product.org_price * (product.amount || 1) + ((parseFloat(product.deposit) || 0) * (product.amount || 1))) }}
                            </span>
                            <br v-if="product.org_price">
                            <span v-if="type == 'credit'" class="text-danger">
                                -&euro;&nbsp;{{ number_format(calculateTotalWithDiscount(product)) }}
                            </span>
                            <span v-else :class="product.org_price ? 'has-text-success' : ''">
                                &euro;&nbsp;{{ number_format(calculateTotalWithDiscount(product)) }}
                            </span>
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <div v-if="showTotals && record">
            <hr>
            <!-- Show discount total if any products have discounts -->
            <div class="row" v-if="hasDiscounts && totalDiscountAmount > 0">
                <div class="columns">
                    <div class="column is-4">&nbsp;</div>
                    <div class="column">&nbsp;</div>
                    <div class="column">&nbsp;</div>
                    <div class="column text-right">
                        <strong>Korting BTW</strong><br>
                        <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                        <span v-else class="has-text-danger">-&euro;&nbsp;{{ number_format(totalDiscountBtw) }}</span>
                    </div>
                    <div class="column text-right">
                        <strong>Korting</strong><br>
                        <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                        <span v-else class="has-text-danger">-&nbsp;&euro;&nbsp;{{ number_format(totalDiscountAmount) }}</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="columns">
                    <div class="column is-4">&nbsp;</div>
                    <div class="column">&nbsp;</div>
                    <div class="column">&nbsp;</div>
                    <div class="column text-right">
                        <strong>Totaal BTW</strong><br>
                        <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                        <span v-else>
                            <span v-if="hasDiscounts && totalOriginalBtw > parseFloat(record.btw)" style="text-decoration: line-through; color: #999; font-size: 0.9em;">
                                &euro;&nbsp;{{ number_format(totalOriginalBtw) }}
                            </span>
                            <br v-if="hasDiscounts && totalOriginalBtw > parseFloat(record.btw)">
                            &euro;&nbsp;{{ record.btw }}
                        </span>
                    </div>
                    <div class="column text-right">
                        <strong>Totaal</strong><br>
                        <span v-if="type == 'credit'" class="text-danger">
                            <span v-if="hideSensitiveData">- &euro;&nbsp;*****</span>
                            <span v-else>
                                <span v-if="hasDiscounts && totalOriginalPrice > parseFloat(record.total)" style="text-decoration: line-through; color: #999; font-size: 0.9em;">
                                    -&euro;&nbsp;{{ number_format(totalOriginalPrice) }}
                                </span>
                                <br v-if="hasDiscounts && totalOriginalPrice > parseFloat(record.total)">
                                -&nbsp;&euro;&nbsp;{{ record.total }}
                            </span>
                        </span>
                        <span v-else>
                            <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                            <span v-else>
                                <span v-if="hasDiscounts && totalOriginalPrice > parseFloat(record.total)" style="text-decoration: line-through; color: #999; font-size: 0.9em;">
                                    &euro;&nbsp;{{ number_format(totalOriginalPrice) }}
                                </span>
                                <br v-if="hasDiscounts && totalOriginalPrice > parseFloat(record.total)">
                                &euro;&nbsp;{{ record.total }}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductsSummary',

    props: {
        type: {
            type: String,
            required: false,
            default: 'view'
        },
        products: {
            type: Array,
            required: false,
            default: () => []
        },
        record: {
            type: Object,
            required: false,
            default: () => {}
        },
        showTotals: {
            type: Boolean,
            required: false,
            default: false
        },
        editingProducts: {
            type: Boolean,
            required: false,
            default: false
        },
        includedIn: {
            type: String,
            required: false,
            default: ''
        },
        type: {
            type: String,
            required: false,
            default: 'invoice'
        }
    },

    computed: {
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        hasDiscounts() {
            return this.products.some(product => product.discount_type && product.discount_value)
        },

        totalDiscountAmount() {
            return this.products.reduce((sum, product) => {
                if (!product.org_price) return sum;
                const amount = product.amount || 1;
                const originalTotal = product.org_price * amount;
                const discountedTotal = parseFloat(product.price) * amount;
                return sum + (originalTotal - discountedTotal);
            }, 0);
        },

        totalDiscountBtw() {
            return this.products.reduce((sum, product) => {
                if (!product.org_price) return sum;
                const originalBtw = this.calculateOriginalBtw(product);
                const discountedBtw = parseFloat(product.btw_price) || 0;
                return sum + (originalBtw - discountedBtw);
            }, 0);
        },

        totalOriginalPrice() {
            return this.products.reduce((sum, product) => {
                const amount = product.amount || 1;
                const price = product.org_price || parseFloat(product.price) || 0;
                const deposit = parseFloat(product.deposit) || 0;
                return sum + (price * amount) + (deposit * amount);
            }, 0);
        },

        totalOriginalBtw() {
            return this.products.reduce((sum, product) => {
                if (product.org_price) {
                    return sum + this.calculateOriginalBtw(product);
                }
                return sum + (parseFloat(product.btw_price) || 0);
            }, 0);
        }
    },

    methods: {
        number_format(val, decimals = 2) {
            val = parseFloat(val)
            return val.toFixed(decimals)
        },

        calculateOriginalBtw(product) {
            if (!product.org_price) return parseFloat(product.btw_price) || 0;

            // Calculate original BTW from original price
            const amount = product.amount || 1;
            const btw = parseFloat(product.btw) || 0;

            // Reverse calculate: if business customer, btw was added; if normal, btw was included
            // For simplicity, use the ratio method
            const currentTotal = parseFloat(product.price) * amount;
            const originalTotal = product.org_price * amount;
            const currentBtw = parseFloat(product.btw_price) || 0;

            if (currentTotal > 0) {
                const ratio = originalTotal / currentTotal;
                return currentBtw * ratio;
            }

            return currentBtw;
        },

        calculateBtwPriceWithDiscount(product) {
            // BTW price is already calculated with discount applied in backend
            return parseFloat(product.btw_price) || 0
        },

        calculateTotalWithDiscount(product) {
            // Price is already discounted in backend, just calculate total
            const amount = product.amount || 1
            const price = parseFloat(product.price) || 0
            const deposit = parseFloat(product.deposit) || 0

            return (amount * price) + (deposit * amount)
        }
    }
}
</script>
